import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const HomeSolid = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={24}
    height={24}
    ref={ref}
    {...props}
  >
    <g>
      <path d="M4.187 12.139a.5.5 0 0 0-.19.393v5.555a3 3 0 0 0 3 3h2.5a.5.5 0 0 0 .5-.5V15.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5.087a.5.5 0 0 0 .5.5h2.5a3 3 0 0 0 3-3v-5.554a.5.5 0 0 0-.192-.393l-7.493-5.897a.5.5 0 0 0-.618 0z" />
      <path d="m3.363 11.514 7.713-6.058a1.5 1.5 0 0 1 1.854.001l7.695 6.055a.5.5 0 0 0 .64-.138l.626-.833a.5.5 0 0 0-.09-.692l-3.805-3.014V4.587a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.663L14.25 3.867l-.002.003-.39-.31a3 3 0 0 0-3.724.001l-.39.31-.003-.004L2.19 9.85a.5.5 0 0 0-.09.692l.626.833a.5.5 0 0 0 .637.14" />
    </g>
  </svg>
);

const ForwardRef = forwardRef(HomeSolid);
export default ForwardRef;
